import { render, staticRenderFns } from "./UiCountdown.vue?vue&type=template&id=649e93c5&lang=pug&"
import script from "./UiCountdown.vue?vue&type=script&lang=js&"
export * from "./UiCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports